module.exports = __webpack_public_path__ + "img/wulu-logo-512x512.9732f938.png";